// extracted by mini-css-extract-plugin
module.exports = {"feather":"logo-module--feather--1K5FL","logo":"logo-module--logo--3RFCU","logoLight":"logo-module--logo-light--mzQNj","hline":"logo-module--hline--Bk51D"};